"use client";

import { useSession, signOut } from "next-auth/react";
import Link from "next/link";
import { LogOut, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";

export function UserMenu() {
  const { data: session, status } = useSession();

  if (status === "loading") {
    return (
      <div className="h-8 w-8 animate-pulse rounded-full bg-muted" />
    );
  }

  if (!session) {
    return (
      <Link href="/login">
        <Button variant="ghost" size="sm" className="gap-2">
          <LogIn className="h-4 w-4" />
          <span className="hidden sm:inline">로그인</span>
        </Button>
      </Link>
    );
  }

  const firstName = session.user.name?.split(" ")[0] ?? "사용자";

  return (
    <div className="flex items-center gap-1.5">
      {/* 프로필 (마이페이지 링크) */}
      <Link
        href="/mypage"
        className="flex items-center gap-2 rounded-full border border-border bg-muted/30 py-1 pl-1 pr-3 transition-colors hover:bg-muted/60"
      >
        {session.user.image ? (
          <img
            src={session.user.image}
            alt={session.user.name ?? "프로필"}
            className="h-7 w-7 rounded-full object-cover"
            referrerPolicy="no-referrer"
          />
        ) : (
          <div className="flex h-7 w-7 items-center justify-center rounded-full bg-primary text-[10px] font-medium text-primary-foreground">
            {firstName[0]?.toUpperCase() ?? "U"}
          </div>
        )}
        <span className="hidden text-xs font-medium sm:inline">
          {firstName}
        </span>
      </Link>

      {/* 로그아웃 버튼 */}
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8 text-muted-foreground hover:text-destructive"
        onClick={() => signOut({ callbackUrl: "/" })}
        title="로그아웃"
      >
        <LogOut className="h-4 w-4" />
      </Button>
    </div>
  );
}
